import { z } from "zod";
import { searchSiteFieldSchema, searchSiteFilterTypeSchema } from "~domain/sites/models/site-search-model.ts";

export const searchSiteRequestBodySchema = z
  .object({
    field: searchSiteFieldSchema,
    filterType: searchSiteFilterTypeSchema,
    value: z.string().or(z.number()),
  })
  .array();
